import {
  Box,
  Checkbox,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import ButtonComponent from "../Widgets/Button";
import AlertComponent from "../Widgets/Alert";
import { COLONNE_TYPES } from "./utils";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";

const AddColumnComponent = ({ addColumns, cancelAddingColumns }) => {
  const [colonne, setColonne] = useState({
    name: "",
    subName: null,
    displayInDashboard: true,
    type: COLONNE_TYPES[0].key,
    options: null,
    position: null,
  });

  const [displayError, setDisplayError] = useState(null);

  const handleChangeColonneType = (e) => {
    setDisplayError(null);
    const target = e.target.value;
    setColonne({
      ...colonne,
      type: target,
      options: target === "multi" ? [""] : null,
    });
  };

  const handleChangeOption = (e, i) => {
    setDisplayError(null);
    const temp = [...colonne.options];
    temp[i] = e.target.value;
    setColonne({
      ...colonne,
      options: temp,
    });
  };

  const handleAddNewOptions = () => {
    setDisplayError(null);
    const temp = [...colonne.options];
    temp.push("");
    setColonne({
      ...colonne,
      options: temp,
    });
  };

  const deleteOptions = (i) => {
    const temp = [...colonne.options];
    temp.splice(i, 1);
    setColonne({
      ...colonne,
      options: temp,
    });
  };

  const handleChangeDisplayInDashboard = (isCheck) => {
    setColonne({
      ...colonne,
      displayInDashboard: isCheck,
    });
  };

  const validateColumn = () => {
    const tempColonne = {
      ...colonne,
      options: colonne.options?.filter((opt) => opt.trim().length !== 0),
    };
    if (colonne.name.trim().length > 0) {
      if (colonne.type === "multi") {
        if (tempColonne.options.length > 1) {
          addColumns(tempColonne);
        } else {
          setDisplayError("Minimum 2 options valides");
        }
      } else {
        addColumns(tempColonne);
      }
    } else {
      setDisplayError("Le nom de la colonne doit être remplie");
    }
  };

  return (
    <>
      <Box mt="10px">
        <Typography>Titre de la nouvelle colonne:</Typography>
        {displayError && <AlertComponent severity="error" msg={displayError} />}
        <TextField
          fullWidth
          required
          id="nom_colonne"
          variant="outlined"
          value={colonne.name}
          onChange={(e) => {
            setColonne({
              ...colonne,
              name: e.target.value,
            });
          }}
        />
      </Box>

      <Box mt="10px">
        <Typography>Sous-titre de la nouvelle colonne (non-obligatoire)</Typography>
        <TextField
          fullWidth
          id="subnom_colonne"
          variant="outlined"
          value={colonne.subName}
          onChange={(e) => {
            setColonne({
              ...colonne,
              subName: e.target.value,
            });
          }}
        />
      </Box>
      <Box mt='10px' display="flex" alignItems="center">
        <Typography>Apparaît dans le Dashboard :</Typography>
        <Checkbox
          onChange={(e) => handleChangeDisplayInDashboard(e.target.checked)}
          checked={colonne.displayInDashboard}
        />
      </Box>

      <Box mt="10px">
        <Typography>Type de colonne:</Typography>
        <Select
          fullWidth
          labelId="colonne-type"
          id="colonne-type"
          value={colonne.type}
          label="Type"
          onChange={handleChangeColonneType}
        >
          {COLONNE_TYPES.map((c) => (
            <MenuItem key={c.name} value={c.key}>
              {c.name}
            </MenuItem>
          ))}
        </Select>
      </Box>
      {colonne.type === "multi" &&
        colonne.options.map((option, i) => (
          <div style={{ display: "flex" }}>
            <TextField
              placeholder="Option 1"
              id={i}
              variant="outlined"
              value={option}
              onChange={(e) => handleChangeOption(e, i)}
            />
            <IconButton>
              <RemoveCircleIcon
                color="internalSecondary"
                onClick={() => {
                  deleteOptions(i);
                }}
              />
            </IconButton>
            <IconButton>
              <AddCircleIcon
                color="internalPrimary"
                onClick={handleAddNewOptions}
              />
            </IconButton>
          </div>
        ))}
      <div style={{ display: "flex", gap: "10%", justifyContent: "center" }}>
        <ButtonComponent title="Annuler" onClickMethod={cancelAddingColumns} />
        <ButtonComponent
          color="success"
          title="Valider"
          onClickMethod={validateColumn}
        />
      </div>
    </>
  );
};

export default AddColumnComponent;
